export default {"src":"/_next/static/media/love_icon.21cf6de5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};